import React from 'react';
import { ButtonWithDropdown } from '@xingternal/winery-ui/lib/ButtonWithDropdown';
import { TextClamp } from '@ui/core/text/TextClamp';

const ButtonMenu = ({ items }) => {
  return (
    <>
      {items.map(
        ({ item, buttonIcon, action, disabled = false, datatestid }) => (
          <ButtonWithDropdown.Button
            key={item}
            icon={buttonIcon}
            disabled={disabled}
            data-testid={datatestid}
            onClick={action}
          >
            <TextClamp>{item}</TextClamp>
          </ButtonWithDropdown.Button>
        ),
      )}
    </>
  );
};

export { ButtonMenu };
